<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'A PKCS#12 keystore is a secure container for your private key and certificate, used to sign Android APKs and App Bundles before publishing to Google Play or other distribution channels.'
    "
    [icon]="'@tui.info'"
    [subtitle]="'About'"
    [title]="'What is an Android Keystore?'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    @for (feature of features; track feature.title) {
      <div
        class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="flex flex-row items-center">
          <tui-icon [icon]="feature.icon" class="mr-2" />
          <h3 class="text-xl font-bold">{{ feature.title }}</h3>
        </div>
        <p class="text-pretty text-lg">
          {{ feature.description }}
        </p>
      </div>
    }
  </div>
</section>
